import React from 'react';
import WatchSystem from '../../WatchSystem/WatchSystem';
import { CUSTOMER_VIEW_CUSTOMER } from '../../../Constants';
import { useTranslation } from 'react-i18next';
import { formatLocalPhone } from '../../../Helper';

export default function ClockSystem(props) {
  const { t } = useTranslation();

  return (
  <div className='customer-watch-wrapper'>
    <div className='controls-wrapper'>
        <div className='controls'>
          <div className='text'>
            <strong>{t("Block List Management")}</strong>
            <span>{t("for")}:</span>
          </div>
          <div className='switch-entity'>
            {(
              props.entityType === "line" ?
              <div className='text'>{props.line.use_name} | {formatLocalPhone(props.line.number)}</div> :
              <div className='text'>{props.customer.name} | {formatLocalPhone(props.customer.phone)}</div>
            )}
          </div>
        </div>
        <div className='search'>
          <div className='back'
            onClick={(e) => {
              props.setCustomerView(CUSTOMER_VIEW_CUSTOMER);
            }}
          >
            <div className='text'>{t("Back to the customer information")}</div>
            <img src='/design-images/arrow-left.svg' className='arrow-left' />
          </div>
        </div>
      </div>
      <div className="ci-override-notice">
        <div className='ci-override-notice-icon'>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <div className='ci-override-notice-text'>
          {t("Please note that the configurations on customer and line level will precede the community configurations.")}
        </div>
      </div>
      <WatchSystem
        isDesktop={true}
        entityType={props.entityType} 
        lineId={(props.entityType === "line" ? props.line.id : null)} 
        customerId={props.customer.id}
      ></WatchSystem> 
  </div>)
}
